<div
  class="blank__image__wrapper"
>
  <div class="mat-headline-5 bolder">
    {{ headline }}
  </div>
</div>
